import mock from 'mockjs'
// 接口名称：报表获取分组及明细
let dataReportGroup = [
  {
    id: 1,
    label: '我的设备',
    items: [
      {
        id: 11,
        typeName: '波浪浮标',
        params: [
          { id: 1, name: '浪高' },
          { id: 2, name: '波周期' },
          { id: 3, name: '波向' },
          { id: 4, name: '电压值' }
        ],
        data: [
          {
            id: 10,
            equipid: 12,
            equipmentnm: '波浪浮标'
          },
          {
            id: 13,
            equipid: 13,
            equipmentnm: '波浪浮标-马老师'
          }
        ]
      },
      {
        id: 12,
        typeName: '表面漂流浮标',
        params: [
          { id: 1, name: '浪高' },
          { id: 2, name: '波周期' },
          { id: 3, name: '波向' },
          { id: 4, name: '电压值' }
        ],
        data: [
          {
            id: 4,
            equipid: 6,
            equipmentnm: '表面漂流浮标'
          },
          {
            id: 5,
            equipid: 7,
            equipmentnm: '表面漂流浮标'
          },
          {
            id: 6,
            equipid: 8,
            equipmentnm: '表面漂流浮标'
          },
          {
            id: 7,
            equipid: 9,
            equipmentnm: '表面漂流浮标'
          },
          {
            id: 9,
            equipid: 11,
            equipmentnm: '表面漂流浮标'
          }
        ]
      }
    ]
  }
  // ,
  // {
  //   id: 2,
  //   label: '共享设备',
  //   items: [
  //     {
  //       id: 21,
  //       typeName: '波浪浮标',
  //       params: [
  //         { id: 1, name: '浪高' },
  //         { id: 2, name: '波周期' },
  //         { id: 3, name: '波向' },
  //         { id: 4, name: '电压值' }
  //       ],
  //       data: [
  //         {
  //           id: 20,
  //           equipid: 12,
  //           equipmentnm: '波浪浮标'
  //         },
  //         {
  //           id: 23,
  //           equipid: 13,
  //           equipmentnm: '波浪浮标-马老师'
  //         }
  //       ]
  //     }
  //   ]
  // }
]
// 接口名称：设备报表
let dataReport = [
  {
    name: '波浪浮标',
    type: 'line',
    data: [['2016/01/04', 1002], ['2016/01/07', 3002], ['2016/01/09', 602]]
  },
  {
    name: '波浪浮标-马老师',
    type: 'line',
    data: [['2016/02/04', 12], ['2016/03/07', 302], ['2016/03/09', 2]]
  }
]

mock.mock('/mock/reportGroup', 'get', dataReportGroup)
mock.mock('/mock/report', 'get', dataReport)
